<div class="w-100 mt-0 tool-container">
  <h4>Download All Unit Profiles</h4>
  <mat-form-field class="me-2">
    <mat-label>Application</mat-label>
    <mat-select [(ngModel)]="downloadAllProfiles.app">
      @for (app of applications; track app.value) {
        <mat-option [value]="app.value">
          {{ app.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <span class="radio-container ps-2 me-3">
    <mat-label>Extended</mat-label>
    <mat-radio-group [(ngModel)]="downloadAllProfiles.extended">
      <mat-radio-button [value]="true" class="me-3">True</mat-radio-button>
      <mat-radio-button [value]="false">False</mat-radio-button>
    </mat-radio-group>
  </span>
  <button
    mat-raised-button
    color="primary"
    class="me-2"
    (click)="getAllProfiles()"
    [disabled]="!downloadAllProfiles.app"
  >
    Download
  </button>
  <button
    mat-stroked-button
    color="primary"
    (click)="getAllProfiles(true)"
    [disabled]="!downloadAllProfiles.app"
  >
    Download as Excel
  </button>
  @if (downloadAllProfiles.status) {
    <h4 class="col-12 {{ downloadAllProfiles.statusClass }}">
      {{ downloadAllProfiles.status }}
    </h4>
  }
</div>
